/// <reference path="./../Entity/FSApp.ts" />
/// <reference path="./Service.ts" />
/// <reference path="../Repository/App.ts" />
namespace HA.Core.Service {

    import AppEntity = HA.Core.Entity.App;
    import AppRepository = HA.Core.Repository.App;
    import FSApp = HA.Core.Entity.FSApp;
    import Tag = HA.Core.HTML.Tag;
    import HANavigationApp = HA.Core.Entity.HANavigationApp;
    import HAApp = HA.Core.Entity.HAApp;

    export class App extends Service {

        /**
         *
         * @param data
         * @returns {HA.Core.Entity.FSApp}
         */
        public static createFSApp(data: any): FSApp {
            return new FSApp(data);
        }

        public getService(id: string) {
            return this.get(id);
        }

        public getWebPageService(): IWebPageService {
            return this.get("ha.service.webpage");
        }

        public showExtPage(url: string): string | number {
            const app = HA.Core.Service.App.createFSApp(
            new HA.Core.HTML.ExtWindow(toMap({src: "/file/?redirect2=" + url})));
            this.showFSApp(app);
            return app.getId();
        }

        public createAndShowFSApp(data: any): string | number {
            const app = HA.Core.Service.App.createFSApp(data);
            this.showFSApp(app);
            return app.getId();
        }

        public showFSApp(app: FSApp): void {
            this.getWebPageService().showFSApp(app);
        }

        public closeFSApp(id: string): void {
            this.getWebPageService().removeApp(id);
        }

        /**
         *
         * @param data
         * @param isNavigation
         * @returns {any|HTMLElement}
         */
        public findById(data: Map<string, any>, isNavigation?: boolean) {

            data.delete("cb");
            const data2 = toMap(data);
            return this.getAppRepository().findById(data2, isNavigation);

        }

        public createApp(
            data: Map<any, any>,
            elementData: Map<any, any>,
            isNavigation?: boolean,
            nav?: HANavigationApp
        ): AppEntity | HAApp | HANavigationApp | HA.Core.Entity.FSApp {
            return this.getAppRepository().createApp(data, elementData, isNavigation)
        }

        public processAction(data: Map<any, any>) {
            switch (data.get("t") ?? data.get("todo")) {
                case  "toggleApp" :
                    this.getWebPageService().toggleApp(data);
                    break;
                case  "showApp" :
                    this.getWebPageService().showApp(data);
                    break;
                case "app" :
                case  "reloadApp" :
                    this.getWebPageService().reloadApp(data);
                    break;
                case  "rc" :
                case  "reloadCurrent" :
                    this.getWebPageService().reloadApp(null);
                    break;
                case  "showAppMenu" :
                    this.getWebPageService().showAppMenu(data);
                case  "showModal" :
                case  "sm" :
                    data.set("_m", "modal");
                    this.getWebPageService().showModal(data);
                    break;
                case  "rma" :
                    this.getWebPageService().removeApp(data.get("id"));
                    break;
                case  "rmc" :
                    this.getWebPageService().removeCurrentApp();
                    break;
                case  "rnav" :
                    this.getWebPageService().reloadNav();
                case  "rp" :
                    this.getWebPageService().reloadPreviousApp();
                    break;
                case  "service" :
                    const service = getService(data.get("id"));
                    service.process(data);
                    break;
                case  "msg" :
                    log(data);
                    break;
                case  "bulk" :
                case  "steps" :
                    this.processBulkAction(data.get("steps"));
                    break;
                case  "notw" :
                    NOTIFICATION.watch(data);
                    break;
                case  "idle" :
                    timeout(() => {
                        this.processAction(toMap(data.get("data")))
                    }, data.get("d"));
                    break;
                case "url":
                    timeout(() => {
                        window.open(data.get("url"), data.get("target"));
                    }, 1000);
                    break;
                case "dom":
                    this.updateDom(data);
                    break;
                case "cc":
                    this.getAppRepository().clearCache();
                    break;
                default :
                    //log2(['pa', data]);
                    break;
            }
        }

        protected updateDom(data: Map<any, any>): void {
            const doma: any = "" + data.get("doma");
            switch (doma) {
                case "repl":
                    let t: Tag;
                    if(data.has("eid")) {
                        t = (new Tag()).findById(data.get("eid"), true);
                    } else {
                        t = (new Tag()).findByQuery(data.get("eq"));
                    }
                    t.clear();
                    t.appendChild(new Tag(data.get("c")));
                    break;
                default:
            }
        }

        /**
         *
         * @param id
         */
        public removeApp(id: string) {
            this.getAppRepository().remove(id);
        }

        protected processBulkAction(data: any[]) {
            for (const item of data) {
                this.processAction(toMap(item));
            }
        }

        public getAppRepository(): AppRepository {

            if (!this.get("appRepository")) {
                this.addToData("appRepository", new AppRepository(toMap(this.getData())));
            }
            return this.get("appRepository");
        }
    }
}
